/**
 * @file: context.tsx
 *
 * The chat thread-list context. Provided by `ChatThreadsProvider`
 * (see `./provider`) and read via `useChatThreads()`.
 */

import { createContext, useContext } from 'react';
import { ChatThreadsStore } from './types';

export const ChatThreadsContext = createContext<ChatThreadsStore | null>(null);

export function useChatThreads(): ChatThreadsStore {
  const ctx = useContext(ChatThreadsContext);
  if (!ctx) {
    throw new Error('useChatThreads must be used within a ChatThreadsProvider');
  }
  return ctx;
}
